import styled from "styled-components";
import { Select } from "antd";
export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 12px;
`;

Wrap.Title = styled.h1`
  font-weight: 700;
  font-size: 28px;
  line-height: 33px;
  color: #313e47;
`;

Wrap.Card = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #f3f4f5;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 24px;
`;

Wrap.Items = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 20px;
  flex-wrap: wrap;
`;

Wrap.CardTitle = styled.h3`
  font-weight: 500;
  font-size: 19px;
  line-height: 16px;
  margin: 25px 0;
`;
Wrap.Item = styled.div`
  display: flex;
  flex-direction: column;

  span {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #313e47;
    margin-bottom: 4px;
  }
`;

Wrap.Input = styled.input`
  width: 238px;
  height: 32px;
  background: #fafafa;
  /* opacity: 0.3; */
  outline: none;
  color: #313e47;
  padding-left: 16px;
  border: 0.4px solid #c1c5c8;
  border-radius: 2px;
`;

Wrap.Select = styled(Select)`
  min-width: 40px;
  font-family: var(--appPrimaryFont);
  font-style: normal;
  font-weight: normal;
  display: flex;
  justify-content: center;
  font-size: 16px;
  height: 32px;
  color: #313e47;
  text-align: center;
  border-radius: 3px !important;
  outline: none;

  line-height: 32px;
  border: ${(borderC) => (borderC ? borderC : "")};
  background: ${(bg) => (bg ? bg : "")} !important;
  .ant-select-selection-placeholder {
    line-height: 32px;
  }
  .ant-select-selector {
    position: relative;
    background: ${(bg) => (bg ? bg : "")} !important;
    font-family: var(--appPrimaryFont);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;

    width: 100%;
    min-width: 120px;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 32px !important;
    text-align: center;
    border: none;
    border: ${(borderC) => (borderC ? borderC : "")};

    border-radius: 3px !important;
    /* line-height: 34px; */
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    padding: 0 !important;
  }
  .ant-select-arrow {
    color: ${(fcolor) => (fcolor ? fcolor : "")} !important;
  }
  .ant-select-selection-item {
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${(fcolor) => (fcolor ? fcolor : "")} !important;

    line-height: 29px !important;
  }
  .ant-select:hover .ant-select-selector,
  .ant-select:focus .ant-select-selector,
  .ant-select:active .ant-select-selector {
    border-color: #fff !important;
    border-right-width: 1px !important;
  }
  .ant-select-selection-item,
  .ant-select-selection-item {
    width: 120px !important;
    text-overflow: ellipsis !important;
  }
`;
Wrap.Buttons = styled.div`
  display: flex;
  align-items: center;
  margin-top: 40px;
`;

Wrap.Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 44px;
  color: ${({ color }) => (color ? color : "#313E47")};
  background: ${({ bg }) => (bg ? bg : "#fff")};
  border: 1px solid #e7ebf3;
  box-sizing: border-box;
  border-radius: 2px;
  margin-left: ${({ mr }) => (mr ? mr : "16px")};
`;
